import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-valor-info',
  templateUrl: './valor-info.component.html',
  styleUrls: ['./valor-info.component.scss']
})
export class ValorInfoComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }
  url = environment.valorWebHook;

  ngOnInit(): void {
  }

}
